// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_Zlp","cls2":"ReferenceEvaluationPage-cls2_wu2 ReferenceEvaluationPage-cls1_Zlp"};